
import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { User, LogIn, LogOut } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/providers/AuthProvider";

const gold = "text-heaven-gold";

const AccountButton = ({
  onSignOut
}: { onSignOut: () => void }) => {
  const { user } = useAuth();
  const navigate = useNavigate();

  if (user) {
    return (
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button
            variant="outline"
            className="ml-3 border-heaven-gold/40 px-5 py-2 bg-white rounded-full shadow hover:bg-heaven-gold/10 transition"
          >
            <User className={`h-5 w-5 mr-2 ${gold}`} />
            <span className={`${gold} font-semibold`}>Account</span>
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent
          align="end"
          className="bg-white z-[100] border border-heaven-gold/30 shadow-lg"
          sideOffset={8}
        >
          <DropdownMenuLabel className={`${gold} px-3`}>My Account</DropdownMenuLabel>
          <DropdownMenuSeparator />
          <DropdownMenuItem onClick={() => navigate("/dashboard")} className="px-3 py-2">
            <span className={`${gold} mr-2`}>🏠</span>
            Dashboard
          </DropdownMenuItem>
          <DropdownMenuItem onClick={() => navigate("/profile")} className="px-3 py-2">
            <User className="h-4 w-4 mr-2 text-heaven-gold" />
            Profile
          </DropdownMenuItem>
          <DropdownMenuSeparator />
          <DropdownMenuItem onClick={onSignOut} className="px-3 py-2">
            <LogOut className="h-4 w-4 mr-2 text-heaven-gold" />
            Sign out
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    );
  }
  // Not signed in
  return (
    <Link to="/sign-in">
      <Button
        variant="outline"
        className="ml-3 border-heaven-gold/40 px-5 py-2 bg-white rounded-full shadow hover:bg-heaven-gold/10 transition"
      >
        <LogIn className={`h-5 w-5 mr-2 ${gold}`} />
        <span className={`${gold} font-semibold`}>Sign In</span>
      </Button>
    </Link>
  );
};

export default AccountButton;
